import { oz } from '@weft/utils';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { GetInvoicesStatisticsResponseSchema } from './get-invoice-statistics-response-schema';
import { GET_INVOICES_STATISTICS_PATH } from './get-invoices-statistics-path';

const CUSTOMER_ID_PATH_PARAM = {
  name: 'customerId',
  location: 'query',
  schema: oz.string().optional(),
  required: false,
} as const satisfies ZapiParam;

export const GET_INVOICES_STATISTICS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-invoices-statistics',
  },
  queryParams: {
    [CUSTOMER_ID_PATH_PARAM.name]: CUSTOMER_ID_PATH_PARAM,
  },
  response: {
    name: 'GetInvoicesStatisticsResponse',
    schema: GetInvoicesStatisticsResponseSchema,
  },
  path: GET_INVOICES_STATISTICS_PATH,
} satisfies ZapiAction;

export type GetInvoicesStatisticsAction = typeof GET_INVOICES_STATISTICS_ACTION;